module.exports = __webpack_public_path__ + "static/media/ic-file-text.55a31b19.svg";